export default {
  // sidebar
  sidebarAiArtface: "AI ArtFace",
  sidebarAiEmoji: "AI Emoji",
  sidebarGenerateRecord: "Generate Record",
  sidebarSignout: "退出",
  sidebarSignIn: "登录 / 注册",
  sidebarNotifications: "通知",
  sidebarLiked: "点赞记录",
  sidebarOther: "其他",
  sidebarAiGeneration: "AI图像生成",
  replacement: "AI换装",
  sidebarUserTools: "用户工具",
  sidebarCommunityFeed: "社区",
  sidebarStartHere: "从这里开始",
  sidebarInviteFriends: "邀请好友",
  sidebarMannequinPerson: "人台图",
  sidebarPersonSwap: "真人图",
  sidebarWearingAccessories: "珠宝饰品",
  sidebarProductSceneChange: "商品图",
  historyWorks: "生成记录",

  // home
  artFaceDesc: "🥳魔法头像将您变成另一个自己，让您的头像更加个性化。",
  emojiDesc: "🤪魔法表情包让您的魔法头像动起来，让您的表情更加有趣。",
  createNow: "立即创作",
  igniteCreativity: "点燃创意",
  igniteCreativityDesc: "通过FashionLabs.ai体验时尚的未来",
  betaBtn: "申请内测",
  help: "帮助",
  helpContact: "联系 support@aispark.ai",
  aboutThePlatform: "关于平台",
  magicBanner1: "AI试衣",
  magicBanner1Desc:
    "人工智能自动换装，一张模特图适用百件商品，升级您的产品图片，省去拍摄、时间成本。",
  magicBanner2: "AI超模",
  magicBanner2Desc:
    "人工智能生成的模型和背景，升级您的产品图片，省去拍摄、时间成本。",
  magicBanner3: "AI商品图",
  magicBanner3Desc: "AI生成海量场景图，只需点击几下，即可生成电商商品图片。",
  magicBanner4: "AI绘画",
  magicBanner4Desc: "在几分钟内，创作出令人惊叹的原创艺术作品。",

  // upload
  uploadTopic: "AI ArtFace",
  uploadTitle: "Upload photos and select styles to generate exclusive avatars.",
  uploadTips1: "Add 4-15 photos of the same person",
  uploadTips2: "Click here or drag and drop the photos to upload",
  uploadTips2Disabled: "You can continue to add after deleting pictures",
  uploadTips3: "上传图片即表示您同意我们的",
  uploadTips5: "Add {num} photos to proceed",
  uploadTips7: "Upload limit reached, please select the avatar styles",
  createAvatar: "Generate Avatar",
  createAvatarStyle: "Continue with {num} style(s)",
  insufficientPhotos: "图片数量不够",
  insufficientPhotosTips: "{num1}张图片不符合标准，请至少添加{num2}张",
  success: "成功",
  fail: "失败",
  inadequatePhotos: "Please add at least {num} more",

  viewAll: "查看全部",
  // homepage 中间五张彩色卡片切换swiper;
  homeCircleTitle1: "创建Instagram, TikTok等社媒内容",
  homeCircleTitle2: "创建专业的个人资料头像",
  homeCircleTitle3: "个性的自拍，找到你的真爱	",
  homeCircleTitle4: "制作专属表情包",
  homeCircleTitle5: "像超级英雄一样获得胜利",
  // recordList
  recordListTitle: "生成记录",
  recordListTitleDesc:
    "每次人工智能（AI）都会生成独特的头像。永远不会有相同的结果",
  recordImgNum: "张", //xx张
  recordGenerate: "正在创建", //正在创建
  aiTypes0: "AI Avatars",
  aiTypes1: "AI Emojis",
  // recordAbout: "预计还需", //预计还需
  // recordMinLeft: "分钟",
  recordMinLeft: "预计还需 {num} 分钟",
  createBeatufy: "生成美好，需要时间呵护...",
  recordCheckDetail: "查看详情",
  btnStatusDesc0: "刷新进度",
  btnStatusDesc1: "制作AI Emojis",
  btnStatusDesc2: "重新生成",
  btnStatusDesc100: "立即支付",
  payNum: "支付{num}",
  noDataRecords: "暂无记录",
  //edit/emoji
  editEmojiDesc: "先制作AI头像，再制作AI表情，让您的头像动起来。",
  createAIEmoji: "制作 Emoji",
  quantity: "数量",
  downloads: "下载",
  downloadAll: "下载全部",
  selectAll: "选择全部",
  deselectAll: "取消全选",
  selected: "已选（{num}），生成AI Emoji",
  works: "张",
  stepCreate: "第1步：制作AI Avatar",
  step: "第 {num} 步",
  stepTips: "首先为您制作AI Avatar，然后您继续下一步制作AI Emoji。",
  gotIt: "知道了",
  //homepage cardCircle
  cardArtStylesTopTitle: "50+ Realistic and artistic style",
  cardArtStylesBelowTitle: "suitable for any scene",
  uploadTerms: "用户条款",
  uploadTips4: "和",
  uploadPrivacy: "隐私政策",
  goodExamples: "优秀案例",
  badExamples: "错误案例",
  goodExamplesTips: "真人照或人台图，衣服撑起，没有遮挡，图片清晰",
  badExamplesTips: "平铺图，细节图，图片模糊不清晰",
  // Tabs
  Hot: "热门",
  New: "最新",
  // Generation page
  addNegativePrompt: "添加否定提示词",
  generation: "生成",
  generationHistory: "历史记录",
  deleteAll: "删除全部",
  generateAgain: "重新生成",
  numberOfImages: "图片数量",
  imageDimensions: "图片尺寸",
  imageToImage: "图生图",
  advanced: "高级",
  created: "创建于",
  close: "关闭",
  open: "开启",
  width: "宽度",
  height: "高度",
  steps: "步数",
  scale: "文本强度",
  faces: "面部修复",
  uploadTips6: "添加 {num} 张图片",
  uploadTips8: "将文件拖到此处，或点击上传用于输入",
  uploadTips9: "隐私不可见",
  uploadTips10: "来自作者的参考图",
  uploadTips11: "点击上传用于输入",
  modelName1: "Midjourney风格",
  modelName2: "人物 1.0",
  modelName3: "设计素材 1.0",
  modelName4: "室内设计 1.0",
  estimatedMinutes: "预计 {num} 分钟",
  generationErrorTips01: "无效参数",
  generationErrorTips02: "请调整提示词后重试或稍后重试",
  taskErrorTips01: "生成失败",
  taskErrorTips02: "任务失败，请重试",
  delModalTitle: "确定要删除生成记录么？",
  delModalDesc: "删除后将无法恢复",
  confirm: "确认",
  cancel: "取消",
  delete: "删除",
  inputPrompt: "输入提示词",
  inputNegativePrompt: "输入不想在图像中看到的内容（反向提示词）",
  sameStyle: "制作同款",
  ForwardPromptDetails: "正向提示词:",
  ReversePromptDetails: "反向提示词:",
  publishWork: "发布到社区",
  release: "发布",
  title: "作品名称",
  titlePlaceholder: "请输入作品名称",
  copySuccess: "复制成功",
  wordsError: "抱歉，您输入的信息中包含敏感词：{sum}，请重新输入",
  wordsLimitation: "生成中，请稍后重试",
  iw: "图片权重",
  s: "风格化",
  seed: "随机种子",
  sampler: "采样器",
  iwTips: "生成结果，与参考图和描述文字的相似程度",
  sTips: "数值越小越极简扁平，数值越大越复杂",
  samplerTips:
    "采样器是图片生成的方法，DPM++系列，图片质量更好，Euler 和 DDIM，生成速度更快",
  seedTips: "采用固定的随机种子，下次生成图片时最大限度的进行还原。",
  stepsTips: "步数更高-质量更高，但速度较慢，过30效果递减，建议保持默认",
  scaleTips: "值越高，生成图像越接近你输入的提示词",
  // 登录注册
  signUp: "注册",
  loginTitle: "登录",
  confirmChange: "确认更改",
  email: "邮箱",
  placeholderEmail: "请输入邮箱",
  password: "密码",
  googleLogin: "谷歌登录",
  confirmPassword: "确认密码",
  loginTips0: "我已阅读并同意",
  loginTips1: "注册即表示您同意",
  loginTips2: "用户协议",
  loginTips3: "和",
  loginTips4: "隐私政策",
  forgotPassword: "忘记密码",
  resetTitle: "更改您的密码",
  changeTitle: "找回密码",
  validatePassword: "6-18位，必须包含数字和字母",
  validatePasswordConfirm: "密码不一致，请检查后重试",
  revisePassword: "链接已发送至{num}，前往邮箱点击链接，完成密码修改~",
  registerEmail: "登录链接已发送至{num}，快去激活吧~",
  emailUsed: "邮箱已被使用",
  emailNotActive: "邮箱未激活，请前往邮箱点击链接激活。",
  IncorrectEmailPassword: "邮箱或密码错误",
  accountActivationSuccessful: "账号激活成功",
  emailNotRegistered: "邮箱未注册",
  loginSuccess: "登录成功",
  PayYearly: "按年支付（8折）",
  PayMonthly: "按月支付",
  or: "或",
  switchAccount: "跳过",
  // 提示词分类
  style: "风格",
  art: "样式",
  view: "视角",
  light: "光照",
  material: "材质",
  render: "渲染",
  quality: "图像优化",
  template: "模板",
  // 提示词多语言
  randomPrompt: "随机提示词",
  featuredModels: "选择模型",
  promptStudio: "提示词助手",
  prompt: "提示词",
  promptPlaceholder: "请选择提示词或模板",
  promptTips: "“+”为强调，“-”为弱化",
  pictureSize: "图片尺寸",
  placeholderTxt: "请输入内容",
  // common question
  subscribedTitle: "管理订阅",
  subscribedDesc: "升级解决，释放您的艺术潜力。",
  questionsTitle: "常见问题",
  questionSubTitle: "找不到您要了解的问题？发送邮件至 📮support@fashionlabs.ai",
  question1: "生成AI商品模特需要多长时间？",
  answer1:
    "为了更好保证生成效果，每次任务预计在4小时内完成，如遇高峰排队，预计在24小时内完成，完成后，我们会通过短信通知到您。",
  question2: "怎么样才能达到最好的效果？",
  answer2: "请按照网站中的操作指南（它有详细的说明和示例），进行图片上传。",
  question3: "订阅后的积分有效期多久？",
  answer3:
    "订阅后每月赠送的积分，有效期30天，超出30天，系统会自动清空，再次赠送新一个周期的积分。",
  question4: "单次购买的积分有效期多久？",
  answer4: "单次购买的积分，有效期1年，1年后剩余积分，系统会自动清空。",
  question5: "如果没有使用完成每个月的所有积分，会怎么样？",
  answer5:
    "每月订阅未使用的积分，不会结转到下个月，除非您购买了单次。 单次购买的积分，一年内可用。",
  invitationCode: "邀请码",
  placeholderCode: "请输入邀请码",
  moreSettings: "更多设置",
  // invite friends
  myInvitationCode: "我的邀请码",
  copyInvitationCode: "复制邀请链接",
  invitationRecord: "邀请记录",
  nickname: "昵称",
  registrationTime: "注册时间",
  invitedNum: "邀请人数",
  female: "女",
  male: "男",
  userTools: "用户工具",
  chooseClothing: "选择服装",
  chooseModel: "选择模特",
  excellentCases: "优秀案例",
  excellentCasesDesc: "正面3D图、正面平铺图、人台图（假模特）",
  incorrectCases: "错误案例",
  incorrectCasesDesc: "非正面、非穿着性褶皱、多件服装",
  historyRecords: "历史记录",
  noContentAvailable: "暂无内容",
  unpaidTitle: "未付款",
  generateNow: "立即生成",
  removingBackground: "去除背景中，请稍后...",
  example: "示例",
  eraseTheShort: "擦除衣服内衬",
  erase: "擦除",
  restore: "恢复",
  brushSize: "笔刷大小",
  wear: "穿着",
  in: "在",
  generating: "生成中...",
  uploadDesc: "点击或将照片拖拽到此页面的任意位置上传",
  womenClothes: "女装",
  tops: "上装",
  TShirt: "半袖",
  vests: "背心",
  camisole: "吊带",
  shortJjacket: "短袖外套",
  longJacket: "长袖外套",
  longSleeve: "长袖",
  hoodie: "连帽卫衣",
  shirt: "衬衫",
  bottoms: "下装",
  shortSkirt: "短裙",
  longSkirt: "长裙",
  shorts: "短裤",
  longPants: "长裤",
  fullBody: "全身",
  shortDress: "短袖连衣裙",
  trenchCoat: "风衣",
  strapDress: "吊带连衣裙",
  longDress: "长袖连衣裙",
  menClothes: "男装",
  vest: "马甲",
  stayTuned: "敬请期待",
  next: "下一步",
  uploadProduct: "上传您的新品",
  retry: "重新上传",
  failure: "上传失败",
  failureTips: "图片不合格，请重新添加",
  operationSuccessfully: "操作成功！",
  taskCreatedTip: "任务创建成功！",
  pleaseChooseClothing: "请选择衣服。",
  pleaseChooseModel: "请选择一个模特。",
  estimatedMinutesCount: "预计1-3分钟",
  sendItAway: "发送并开始上传",
  fileFormatError: "文件格式错误",
  createdLimitTips: "正在生成中，请稍后重试",
  fileSizeError: "图片要小于10MB",
  fileWidthHeightError: "图片宽高尺寸，要大于512",
  fileNumError: "最多上传{num}张图片",
  fileNumErrorMax: "超过最大数量限制",
  step1: "上传/选择照片",
  step2: "选择模特&场景",
  step3: "生成图片",
  uploadImage: "上传图片",
  uploadImageTips: "将图片拖放到页面任意位置",
  uploadImageTips2: "最多可选择3张图片",
  selectModel: "选择模特",
  selectModelI1: "女模特",
  selectModelI0: "男模特",
  selectScene: "选择场景",
  select_indoor: "室内",
  select_outdoor: "室外",
  select_solidbackground: "纯色背景",
  again: "重选",
  return: "撤销",
  segmentDesc: "点击选择，图像中要保留的内容",
  segmentDelDesc: "删除后无法恢复数据",
  segmentCheckPicture: "检查图片",
  segmentCheckPictureDesc: "您有{num}张图片尚未处理，请重新检查",
  segmentImageError: "图像格式不符合要求，请重新上传",
  segmentImageError1: "图片宽高需要大于512px",
  segmentImageError2: "图片要求：宽/高≤2",
  segmentUploadError: "正在上传，请等待上传完成后再提交",
  front: "正面",
  side: "侧面",
  back: "背面",
  backBtn: "返回",
  pleaseUpload: "请上传图片",
  addNewProduct: "添加新产品",
  totalImages: "共{num}张",
  regenerate: "再次生成",
  deletePicture: "删除图片",
  deletePictureDesc: "删除后无法恢复数据",
  add: "添加",
  againCreate: "换模特",
  startingUp: "AI启动中...",
  create: "生成",
  taskRetry: "重试",
  deleteSeg: "全部取消",
  processing: "生成中，请稍后~",
  processingLast: "排队中😅，请稍后~",
  uploadFail: "上传失败，请重新上传",
  classname_emotion: "选择表情",
  watermark: "（限时无水印免费）",

  home: "首页",
  myOrders: "我的订单",
  orderDetails: "订单明细",
  product: "产品",
  orderNumber: "订单编号",
  creationTime: "创建时间",
  orderAmount: "订单金额",
  orderStatus: "订单状态",
  operations: "操作",
  refunded: "已退款",
  noPaid: "未支付",
  paid: "已支付",
  myPoints: "我的积分",
  consumePoints: "消耗积分",
  pointName: "名称",
  taskId: "任务ID",
  orderId: "订单ID",
  month: "月",
  invoiceApplication: "申请开票",
  invoiceIssued: "已开票",
  invoiceIssuance: "开具发票",
  addCustomer: "微信扫码添加客服",
  fiveImages: "五张图",
  networkError: "网络错误，请检查您的网络。",
  subscribeNow: "立即开通",
  renewNow: "立即续费",
  memberDiscount: "开通会员享超低折扣",
  remainingPoints: "剩余积分",
  pointsExpirationTime: "积分到期时间，可在会员订阅页查看",
  aiFashionPhoto: "AI服装商拍",
  memberSubscription: "会员订阅",
  pointsPerImage: "每张图片消耗",
  points: "积分",
  package: "套餐",
  expirationTime: "到期时间",
  monthlySubscription: "月订阅",
  annualSubscription: "年订阅",
  singlePurchase: "单次购买",
  buyMorePoints: "购买更多积分",
  payNow: "立即支付",
  off: "折",
  phoneLogin: "手机登录/注册",
  switchAccountTitle: "更换账号",
  goCreate: "去制作",
  uploadRealPerson:
    "上传真人照或人台图，24小时生成AI模特+图片精修告别模特、摄影、场地租赁等高昂费用，省时省力又省钱。",
  uploadRealPersonTips1: "上传服装真人照或人台图",
  uploadRealPersonTips2: "上传想要风格的参考图",
  uploadRealPersonTips3: "输出精修内容并下载",
  emailLogin: "邮箱登录",
  inputPhone: "请输入手机号",
  inputCode: "请输入验证码",
  loginRegister: "登录/注册",
  sendCode: "发送验证码",
  phoneError: "请输入正确的手机号",
  sendCodeSuccess: "已发送（{num}s）",
  codeSendSuccess: "验证码发送成功",
  codeSendError: "操作频繁，请稍后再试",
  codeSendFail: "验证码发送失败，请稍后再试",
  codeError: "验证码错误",
  backToWorkbench: "返回工作台",
  buyMorePointsTitle: "购买更多积分",
  buyMorePointsDesc: "*30天内有效，请在有效时间内使用哦～",
  uploadMaterial: "上传素材",
  uploadReference: "上传参考图",
  downloadRefinement: "精修下载",
  uploadRealPersonTitle: "上传服装真人照或人台图",
  uploadRealPersonDesc: "将图像拖拽至此处或点击上传",
  uploadRealPersonDesc2: "最多可选择{num}张图片",
  uploadReferenceTitle: "上传想要风格的参考图",
  uploadReferenceDesc: "不上传，将会随机生成哟～",
  contactUs: "联系我们",
  addCustomerService: "扫码添加专属客服",
  pointsInsufficient: "积分不足",
  nineYuan: "9.9元",
  pointsConsumption: "消耗{num}积分",
  immediatelyGenerate: "立即生成",
  countdown: "倒计时 {num}s",
  exchangeCode: "兑换码",
  inputExchangeCode: "请输入兑换码",
  exchangeCodeTips: "兑换码不能包含空格",
  pointsExchange: "积分兑换",
  scanCodePayment: "扫码付款",
  aiModelRefinement: "{num}元AI模特精修",
  pointsExchangeModel: "积分兑换{num}张模特图",
  currentPoints: "当前积分",
  immediatelyExchange: "立即兑换",
  useExchangeCode: "使用兑换码",
  estimated: "预计需要 {hours} 小时{minutes}分钟",
  noInvitationCode: "没有邀请码？",
  wechatScanCode: "微信扫码添加客服获取邀请码",
  uploadReferenceTitle2: "上传参考（想做什么样效果？最多上传5张，非必填）",
  inputDescription: "输入描述",
  inputDescriptionTips:
    "输入您的需求，例如：希望是一位欧美女模特，在海边的场景下",
  face_1: "男模特",
  face_2: "女模特",
  face_type_1: "白种人",
  face_type_2: "黄种人",
  face_type_3: "黑种人",
  notChangeModel: "不换模特",
  invitationCodeError: "邀请码错误",
  pointsInsufficientTips: "您的积分不足，请充值后再试",
  pleaseSelectModel: "请选择模特",
  processing1: "预计2小时",
  processingDesc1: "😘 生成中，请稍后～",
  processing2: "当前商家较多",
  processingDesc2: "😘 还要一会儿哦～",
  processing3: "正在打包，请稍后",
  processingDesc3: "🤗️ 完成后你将收到短信通知～",
  processingDescAi3: "🤗️ 完成后你将收到邮件通知",
  userId: "用户ID",
  paymentTime: "付款时间",
  noOrder: "该用户下没有订单",
  aiProduct: "AI商品图",
  uploadProductTitle: "上传商品图",
  tryThese: "试试这些",
  ratio: "图片比例",
  segmentation: "抠图细化",
  uploading: "图片上传中",
  canvasTips: "画布区域为最终的效果区域，可旋转调整物体位置",

  homeBannerTitle1: "致力于构建一个AI工具，让电子商务商家使用AI技术低成本",
  homeBannerTitle2: "高效生成",
  homeBannerTitle3: "的商业拍摄工具",
  homeBannerCate1: "服装真人模特图",
  homeBannerCate2: "商品展示图",
  homeBannerCate3: "手持商品图",
  tryItNow: "立即体验",
  tryTip: "首次体验 ￥9.9/次",
  modelsAl: "Al模特",
  ordinaryToProfessional: "路人生成专业模特",
  changeModels: "根据年龄、肤色、性别等来生成模特",
  mannequinToPerson: "人台生成专业模特",
  convertMannequins: "将人台图转换成模特穿着您的服装",
  headlessImages: "无头的图片生成人脸",
  autoGenerateFaces: "即使图片被裁切，也可自动生成人脸",
  fullBodyModels: "半身图片生成全身模特",
  autoGenerateOutfit: "即使原图被裁切,也会自动生成完整服装",
  productSceneChange: "AI商品图",
  swapBackground: "AI生成海量背景",
  moreAITools: "更多AI工具",
  removeBackground: "智能抠图",
  retouch: "AI消除",
  imageUpscaler: "高清画质",
  whyChooseFashionLabs: "为什么选择FashionLabs",
  shortenTimeToMarket: "缩短上线时间",
  quickProductUpdates: "帮助您快速更新产品，及时发起广告计划",
  reduceShootingCosts: "降低拍摄成本",
  saveTraditionalCosts: "省去传统拍摄成本，低成本的价格获得高质量的效果",
  boostSalesConversion: "提升销售转化",
  stayAheadOfCompetitors: "在竞争者保持领先,给客户留下品牌印象，推动销售增长",
  customerCaseStudies: "客户案例",
  startCreatingProfessionalImages: "开始创造专业的商品摄影图片",
  limitedTimeOffer: "限时福利：还剩14天",
};
